import { Controller } from "@hotwired/stimulus"

// Localize a date in the current language and time zone.
//
// Example:
//
//   <time data-controller="time-format" datetime="2020-05-18T19:22:17Z">
//     2020-05-18 19:22 UTC
//   </time>
//
// In language `es` and time zone `America/New_York` would change the DOM to:
//
//   <time data-controller="time-format" datetime="2020-05-18T19:22:17Z">
//     18 de mayo de 2020, 15:22 GMT-4
//   </time>
export default class extends Controller {
  connect() {
    // Listen for changes in the `lang` attribute.
    this.htmlObserver = new MutationObserver(this.#updateOnHtmlLangChange)
    this.htmlObserver.observe(document.documentElement, { attributes: true })

    this.update()
  }

  update() {
    const language = document.documentElement.lang
    const time = Date.parse(this.element.attributes.datetime.value)
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      timeZoneName: "short",
    }
    const formatted = new Intl.DateTimeFormat(language, options).format(time)
    this.element.innerText = formatted
  }

  #updateOnHtmlLangChange = (mutationList) => {
    mutationList.forEach(mutation => {
      if (mutation.attributeName == "lang") this.update()
    })
  }
}
